// pages/treach/sections/OperationsSection.jsx
import React from "react";

const OperationsSection = () => {
  return (
    <div className="text-gray-200 text-sm">
      <p>🛠️ <strong>Operations Tasks</strong></p>
      <ul className="list-disc list-inside mt-3 text-gray-400">
        <li>Finalize creatives – ✅</li>
        <li>Confirm slots – ⏳</li>
        <li>Share tracking links – ⏳</li>
      </ul>
    </div>
  );
};

export default OperationsSection;
